// VerifyDealer.tsx
import React, { useState, useEffect } from "react";
import { Modal, TextInput, Button, Group, Text, Checkbox, Radio, Stack } from "@mantine/core";
// import { RowDataOrder } from "../OrderPage/types";
import { RowDataCorporate } from "./types";
import classes from "./Corporate.module.css";
import { IconPhoto } from "@tabler/icons-react";

import { formatYYYY_MM_DD_HH_mm } from "../../helper/DateTime";

interface VerifyDealerProps {
  isOpen: boolean;
  onClose: () => void;
  onSaveChanges: (editedOrderr: RowDataCorporate, action: string, remark: string) => void;
  initialData: RowDataCorporate | null; // Allow initialData to be null
}

const VerifyCorporate: React.FC<VerifyDealerProps> = ({
  isOpen,
  onClose,
  onSaveChanges,
  initialData,
}) => {

    const [checked, setChecked] = useState(false);
    const [accountAction, setActionAction] = useState('verify');
    const [remark, setRemark] = useState('');


  const [editedOrder, setEditedOrder] = useState<RowDataCorporate>({
    uid: "",
    fullname: "",
    phone_number: "",
    email: "",
    dob: "",
    company: "",
    corporate_card: "",
    action: "",
    nric_fullname: "",
    nric: "",
    tin: "",
    address_line_1: "",
    address_line_2: "",
    postal: "",
    city: "",
    state: "",
    country: "",
    business_phone_number: "",
    sst_registration_number: "",
    nricImg: "",
    isVerified: false,
    createdAt: "",

    ssm_number: "",
    msic: "",
    submittedAt: "",
  });

  useEffect(() => {
    // Set initialData only if it's a valid object, otherwise keep the default state
    if (initialData) {
      setEditedOrder(initialData);
    }
  }, [initialData]);

  const handleVerifyDealer = () => {
    
    if(!checked){
        alert("Please check the checkbox to confirm");
        return;
    }

    if(accountAction === 'resubmit' && remark.trim().length === 0){
        alert("Please add resubmit remark");
        return;
    }

    onSaveChanges(editedOrder, accountAction, remark.trim());

    setChecked(false)
    setActionAction('verify')
    setRemark('')
  };



  return (
    <Modal
      opened={isOpen}
      title={
        <div style={{ textAlign: "center", fontWeight: "bold" }}>
          Verify Corporate
        </div>
      }
      onClose={onClose}
      size="md"
      padding="lg"
    >
      <div className={classes.editOrderForm}>
        {/* Display fields for editing */}
        <TextInput
          label="Full Name"
          description="Based on NRIC"
          maxLength={255}
          value={editedOrder.nric_fullname}
          readOnly
        />
        <TextInput
          label="NRIC"
          maxLength={255}
          value={editedOrder.nric}
          readOnly
        //   leftSection={<Text fz={14} c='#2D2D2D' lh={'normal'}>+60</Text>}
        />
        {/* {!editedOrder.company ? */}
            {/* <>
            <Text className={classes.Text}>
            NRIC <span className={classes.format}>(Front Image)</span>
            </Text>
            <div className={classes.bannerImageContainer}>
                {editedOrder.nricImg ? (
                <img
                    src={editedOrder.nricImg}
                    alt="NRIC Image"
                    className={classes.bannerImageSize}
                />
                ) : (
                <p>
                    <IconPhoto />
                </p>
                )}
            </div>
            </> */}
        {/*  : */}
        <>
        <TextInput
          label="Company"
          value={editedOrder.company}
          readOnly
        />
        <div>
          <Text size="sm" fw={500} mb={4}>
            Corporate Card
          </Text>
            <div className={classes.inputLikeContainer}>
                <img
                  src={editedOrder.corporate_card}
                  alt="Corporate Card"
                  className={classes.inputImage}
                />
            </div>
        </div>
        <TextInput
          label="SSM Number"
          value={editedOrder.ssm_number}
          readOnly
        />
        <TextInput
          label="TIN"
          value={editedOrder.tin}
          readOnly
        />
        <TextInput
          label="Address Line 1"
          value={editedOrder.address_line_1}
          readOnly
        />
        <TextInput
          label="Address Line 2"
          value={editedOrder.address_line_2}
          readOnly
        />
        <TextInput
          label="Post Code"
          value={editedOrder.postal}
          readOnly
        />
        <TextInput
          label="City"
          value={editedOrder.city}
          readOnly
        />
        <TextInput
          label="State"
          value={editedOrder.state}
          readOnly
        />
        <TextInput
          label="Company Contact"
          value={editedOrder.business_phone_number}
          readOnly
        />
        <TextInput
          label="SST Registration Number"
          description="*Optional"
          value={editedOrder.sst_registration_number}
          readOnly
        />
        <TextInput
          label="MSIC Code"
          value={editedOrder.msic}
          readOnly
        />
        </>
        {/* } */}
        
        <TextInput
          label="Submitted At"
          value={formatYYYY_MM_DD_HH_mm(editedOrder.submittedAt)}
          readOnly
        />

        {/* <Checkbox
            label="I have check this dealer"
            checked={checked}
            onChange={(event) => setChecked(event.currentTarget.checked)}
            mt={'xs'}
        /> */}

        <Radio.Group
        value={accountAction}
        onChange={setActionAction}
        name="accountAction"
        label="Account Action"
        withAsterisk
        mt={'xl'}
        >
            <Stack>
                <Radio value="verify" label="I have check and verify this corporate" />
                <Radio value="resubmit" label="Request corporate to resubmit"/>
                <Radio value="delete" label="Delete account"/>
            </Stack>
        </Radio.Group>

    {accountAction === 'resubmit' ?
        <TextInput
            value={remark}
            onChange={(event) => setRemark(event.currentTarget.value)}
            label="Remark"
        />
    : null}
        

        <Checkbox
            label="I confirmed my selection"
            checked={checked}
            onChange={(event) => setChecked(event.currentTarget.checked)}
            mt={'xl'}
        />

        <Group className={classes.buttonBottom}>
          <Button onClick={() => onClose()} className={classes.buttonCancel}>
            Back
          </Button>
          <Button
            onClick={handleVerifyDealer}
            className={classes.buttonSaveChanges}
          >
            Submit
          </Button>
        </Group>
      </div>
    </Modal>
  );
};

export default VerifyCorporate;
